var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { MdRadioButtonChecked, MdRadioButtonUnchecked } from 'react-icons/md/';
import { themeLss } from "../../lss";
import styled from "../../styled";
var RadioInk = styled.span(themeLss());
var RadioInput = styled.input(themeLss());
var Wrapper = styled.label(themeLss());
export var Radio = function (_a) {
    var checked = _a.checked, disabled = _a.disabled, isInvalid = _a.isInvalid, label = _a.label, lss = _a.lss, required = _a.required, defaultChecked = _a.defaultChecked, props = __rest(_a, ["checked", "disabled", "isInvalid", "label", "lss", "required", "defaultChecked"]);
    var isChecked = defaultChecked || checked;
    var icon = isChecked ? (React.createElement(MdRadioButtonChecked, null)) : (React.createElement(MdRadioButtonUnchecked, null));
    return (React.createElement(Wrapper, { lss: __assign({ display: 'inline-flex', alignItems: 'center', color: isInvalid ? 'danger500' : isChecked ? 'secondary500' : 'inherit', cursor: disabled ? 'not-allowed' : 'default', opacity: disabled ? 'disabled' : 1 }, lss) },
        React.createElement(RadioInput, __assign({ type: "radio", lss: {
                position: 'absolute',
                left: '-100vw'
            }, disabled: disabled, required: required, checked: checked, defaultChecked: defaultChecked }, props)),
        React.createElement(RadioInk, { lss: {
                transition: 'fast',
                borderRadius: 'rounded',
                mr: label ? 'sm' : 0,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center'
            } }, icon),
        label));
};
//# sourceMappingURL=Radio.js.map